<template>
  <header id="page-topbar">
    <div class="navbar-header">
      <div class="d-flex d-flex align-items-center">
        <div class="navbar-brand-box">
          <router-link to="/" class="logo logo-light">
            <span class="logo-sm">
              <img
                :src="URL_LOCAL_FILE + '/images/logo-dxperts-sm.png'"
                alt="D-XPERTS"
                height="25"
              />
            </span>
            <span class="logo-lg">
              <img
                :src="URL_LOCAL_FILE + '/images/logo-dxperts.png'"
                alt="D-XPERTS"
                height="45"
              />
            </span>
          </router-link>
        </div>
        <button
          type="button"
          class="btn btn-sm px-3 font-size-24 header-item"
          id="vertical-menu-btn"
          @click="toggleMenu"
        >
          <i class="mdi mdi-backburger"></i>
        </button>
        <div class="d-sm-block">
          <!--router-link
            to="/planning-budgetaire"
            v-slot="{ href, navigate, isActive, isExactActive }"
            class="side-nav-link-ref"
            active-class="active"
            exact-active-class="active"
            custom
          >
            <a
              :href="href"
              @click="navigate"
              :class="[isActive && 'active', isExactActive && 'exact-active']"
            >
              <i class="ion ion-md-cube"></i>
              <span> Budgets</span>
            </a>
          </router-link-->
          <b-dropdown variant="light" class="d-inline-block">
            <template v-slot:button-content>
              Accès aux modules
              <i class="mdi mdi-chevron-down"></i>
            </template>

            <b-dropdown-item to="/" exact>
              <i class="ion ion-md-speedometer"></i> Dashboard
            </b-dropdown-item>

            <b-dropdown-item to="/crm">
              <i class="ion ion-md-cube"></i> CRM
            </b-dropdown-item>

            <b-dropdown-item to="/achat">
              <i class="ion ion-md-cube"></i> Achat
            </b-dropdown-item>

            <b-dropdown-item to="/rh">
              <i class="ion ion-md-cube"></i> RH
            </b-dropdown-item>

            <b-dropdown-item to="/configuration">
              <i class="ion ion-md-cube"></i> Configurations
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
      <div class="d-flex">
        <!--div class="d-flex align-items-center mx-2">
          <router-link to="/agenda/calendrier" title="Agenda">
            <v-icon> {{ agendaIcons.V_ICON_CALENDAR }} </v-icon>
            <span class="d-none d-md-inline">Agenda</span>
          </router-link>
        </div-->
        <div
          class="d-flex align-items-center d-none ml-2 mr-2"
          role="button"
          v-if="config.langues.length === 0"
        >
          <img
            class="mr-2"
            :src="
              require('@/assets/images/flags/' + currentLangue.code + '.jpg')
            "
            alt="Image"
            height="16"
          />
          {{ $t('top_bar.' + currentLangue.nom.toLowerCase()) }}
        </div>

        <b-dropdown
          v-else
          variant="white"
          right
          class="d-none d-md-block ml-2"
          toggle-class="header-item"
        >
          <template v-slot:button-content>
            <img
              class="mr-2"
              :src="
                require('@/assets/images/flags/' + currentLangue.code + '.jpg')
              "
              alt="Image"
              height="16"
            />
            {{ $t('top_bar.' + currentLangue.nom.toLowerCase()) }}
            <i class="mdi mdi-chevron-down"></i>
          </template>
          <b-dropdown-item
            class="notify-item"
            @click="updateLangue(langue)"
            v-for="(langue, index) in config.langues"
            :key="index"
            v-show="langue.code !== currentLangue.code"
          >
            <img
              :src="require('@/assets/images/flags/' + langue.code + '.jpg')"
              alt="Image"
              class="mr-1"
              height="12"
            />
            <span class="align-middle">{{
              $t('top_bar.' + langue.nom.toLowerCase())
            }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown
          right
          variant="white"
          class="d-inline-block ml-2 mr-2"
          toggle-class="header-item"
        >
          <template v-slot:button-content>
            <img
              v-if="user === null || user.url_image === null"
              :src="URL_LOCAL_FILE + '/images/no-avatar.png'"
              alt="Avatar"
              class="rounded-circle header-profile-user"
            />
            <img
              v-else
              :src="user.url_image"
              alt="Avatar"
              class="rounded-circle header-profile-user"
            />
          </template>

          <!-- item-->
          <b-dropdown-item
            @click.prevent="$router.push('/compte').catch(() => {})"
            active-class="current"
            exact-active-class="current"
            v-if="user && user.profil_type === CONST.EMPLOYE_PROFIL"
          >
            <i
              class="mdi mdi-account-circle font-size-17 align-middle mr-1"
            ></i>
            Mon compte
          </b-dropdown-item>

          <b-dropdown-item
            @click.prevent="$router.push('/profil').catch(() => {})"
            active-class="current"
            exact-active-class="current"
            v-if="user && user.profil_type === CONST.USER_PROFIL"
          >
            <i
              class="mdi mdi-account-circle font-size-17 align-middle mr-1"
            ></i>
            Mon profil
          </b-dropdown-item>

          <b-dropdown-item @click.prevent="logout">
            <span class="text-danger">
              <i class="mdi mdi-logout font-size-17 align-middle mr-1"></i>
              {{ $t('top_bar.deconnexion') }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>

<script>
import config from '@/config';
import URL from '@/http/auth.url';
import { mapGetters } from 'vuex';
import agendaIcons from '@/icons/agenda';
import CONST from '@/constants/auth';
export default {
  data() {
    return {
      URL_LOCAL_FILE: config.URL_LOCAL_FILE,
      agendaIcons,
      CONST,
    };
  },
  computed: {
    ...mapGetters('app', ['config']),
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    logout: function () {
      window.axios.get(URL.LOGOUT).finally(() => {
        this.$store.dispatch('auth/authenticated', false);
        this.$store.dispatch('auth/me', null).then(() => {
          this.$router.push({ name: 'login' });
        });
      });
    },
    updateLangue(langue) {
      if (langue.uuid) {
        //Liste des langues provenant de la BDD
        window.axios
          .put(URL.MY_PROFILE, {
            only_langue_update: true,
            langue: langue.uuid,
          })
          .then(() => {
            this.$store.dispatch('auth/checkUser');
          });
      }
    },
  },
};
</script>
